import { faStar as faRegStar } from '@fortawesome/free-regular-svg-icons';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface InteractiveStarRatingProps {
  value: number;
  onChange: (value: number) => void;
  max?: number;
  className?: string;
}

const InteractiveStarRating: React.FC<InteractiveStarRatingProps> = ({
  value,
  onChange,
  max = 5,
  className = '',
}) => {
  return (
    <div className={`interactive-star-rating ${className}`}>
      {Array.from({ length: max }, (_, i) => i + 1).map((star) => (
        <FontAwesomeIcon
          key={star}
          icon={value >= star ? faStar : faRegStar}
          className={`star-item ${value >= star ? 'active' : ''}`}
          onClick={() => onChange(star)}
          style={{ cursor: 'pointer' }}
        />
      ))}
    </div>
  );
};

export default InteractiveStarRating;
